//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0],[0,"NextSlotPersistentTag",1,0]],[[["numLine"],"GetDescription",{R_:{descLines:""}},0,0],[["descLines"],"SetDescription",{},1,0],[["numSlots"],"GetSlots",{R_:{slots:""}},0,1],[["slots"],"SetSlots",{},1,1],[["numSlots"],"GetSlotsV2",{R_:{slots:""}},0,1],[["numSlots"],"GetSlotsV3",{R_:{slots:""}},0,1],[["slots"],"SetSlotsV2",{},1,1],[["slots"],"SetSlotsV3",{},1,1],[["numExpressions","slotExpressions"],"GetSlotExpressions",{},0,0],[["slotExpreesions"],"SetSlotExpressions",{},1,0],[["templateFile"],"SaveToXmlFile",{},1,0],[["templateFile"],"LoadFromXmlFile",{},1,0]],[]];
SPLM.Mechatronics.ExpressionBlockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ExpressionBlockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ExpressionBlockBuilder.Slot = class{
    constructor(eSlotType,name,eDataType,boolValue,intValue,doubleValue,unit,formula,comment,tgPhysicsObject,nPhysicsPropTag){
        this.eSlotType=eSlotType;this.name=name;this.eDataType=eDataType;this.boolValue=boolValue;this.intValue=intValue;this.doubleValue=doubleValue;this.unit=unit;this.formula=formula;this.comment=comment;this.tgPhysicsObject=tgPhysicsObject;this.nPhysicsPropTag=nPhysicsPropTag;}
    get Eslottype(){return this.eSlotType}
    set Eslottype(val){this.eSlotType = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Boolvalue(){return this.boolValue}
    set Boolvalue(val){this.boolValue = val}
    get Intvalue(){return this.intValue}
    set Intvalue(val){this.intValue = val}
    get Doublevalue(){return this.doubleValue}
    set Doublevalue(val){this.doubleValue = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
    get Tgphysicsobject(){return this.tgPhysicsObject}
    set Tgphysicsobject(val){this.tgPhysicsObject = val}
    get Nphysicsproptag(){return this.nPhysicsPropTag}
    set Nphysicsproptag(val){this.nPhysicsPropTag = val}
};

SPLM.Mechatronics.ExpressionBlockBuilder.SlotV2 = class{
    constructor(eSlotType,name,eDataType,boolValue,intValue,doubleValue,unit,formula,comment,tgPhysicsObject,nPhysicsPropTag,nSlotPersistentTag){
        this.eSlotType=eSlotType;this.name=name;this.eDataType=eDataType;this.boolValue=boolValue;this.intValue=intValue;this.doubleValue=doubleValue;this.unit=unit;this.formula=formula;this.comment=comment;this.tgPhysicsObject=tgPhysicsObject;this.nPhysicsPropTag=nPhysicsPropTag;this.nSlotPersistentTag=nSlotPersistentTag;}
    get Eslottype(){return this.eSlotType}
    set Eslottype(val){this.eSlotType = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Boolvalue(){return this.boolValue}
    set Boolvalue(val){this.boolValue = val}
    get Intvalue(){return this.intValue}
    set Intvalue(val){this.intValue = val}
    get Doublevalue(){return this.doubleValue}
    set Doublevalue(val){this.doubleValue = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
    get Tgphysicsobject(){return this.tgPhysicsObject}
    set Tgphysicsobject(val){this.tgPhysicsObject = val}
    get Nphysicsproptag(){return this.nPhysicsPropTag}
    set Nphysicsproptag(val){this.nPhysicsPropTag = val}
    get Nslotpersistenttag(){return this.nSlotPersistentTag}
    set Nslotpersistenttag(val){this.nSlotPersistentTag = val}
};

SPLM.Mechatronics.ExpressionBlockBuilder.SlotV3 = class{
    constructor(eSlotType,name,eDataType,boolValue,intValue,doubleValue,strValue,unit,formula,comment,tgPhysicsObject,nPhysicsPropTag,nSlotPersistentTag){
        this.eSlotType=eSlotType;this.name=name;this.eDataType=eDataType;this.boolValue=boolValue;this.intValue=intValue;this.doubleValue=doubleValue;this.strValue=strValue;this.unit=unit;this.formula=formula;this.comment=comment;this.tgPhysicsObject=tgPhysicsObject;this.nPhysicsPropTag=nPhysicsPropTag;this.nSlotPersistentTag=nSlotPersistentTag;}
    get Eslottype(){return this.eSlotType}
    set Eslottype(val){this.eSlotType = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Edatatype(){return this.eDataType}
    set Edatatype(val){this.eDataType = val}
    get Boolvalue(){return this.boolValue}
    set Boolvalue(val){this.boolValue = val}
    get Intvalue(){return this.intValue}
    set Intvalue(val){this.intValue = val}
    get Doublevalue(){return this.doubleValue}
    set Doublevalue(val){this.doubleValue = val}
    get Strvalue(){return this.strValue}
    set Strvalue(val){this.strValue = val}
    get Unit(){return this.unit}
    set Unit(val){this.unit = val}
    get Formula(){return this.formula}
    set Formula(val){this.formula = val}
    get Comment(){return this.comment}
    set Comment(val){this.comment = val}
    get Tgphysicsobject(){return this.tgPhysicsObject}
    set Tgphysicsobject(val){this.tgPhysicsObject = val}
    get Nphysicsproptag(){return this.nPhysicsPropTag}
    set Nphysicsproptag(val){this.nPhysicsPropTag = val}
    get Nslotpersistenttag(){return this.nSlotPersistentTag}
    set Nslotpersistenttag(val){this.nSlotPersistentTag = val}
};

SPLM.Mechatronics.ExpressionBlockBuilder.SlotType = Object.freeze({
    "None" : "None", "Input" : "Input", "Output" : "Output", "Param" : "Param", "State" : "State", "Custom" : "Custom", "Num" : "Num"});

SPLM.Mechatronics.ExpressionBlockBuilder.DataType = Object.freeze({
    "Bool" : "Bool", "Int" : "Int", "Double" : "Double", "String" : "String"});

export default SPLM;